module.exports = __webpack_public_path__ + "static/media/logo.de38a13c.png";